import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// Utils
import { tiposDocumentos } from "../../contexto";
// React Bootstrap
import { Form, Button, Col } from "react-bootstrap";

const FormAñadirDocumento = ({ submissionHandler, validation }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <Form.Group as={Col} xs={12} controlId="description-doc-name">
          <Form.Label>{"Nombre del documento *"}</Form.Label>
          <Form.Control
            name="name"
            placeholder={"Nombre"}
            type="text"
            isInvalid={errors?.name}
            {...register("name", {
              required: "Este campo es obligatorio",
              maxLength: {
                value: 80,
                message: "El máximo de caracteres es 80",
              },
            })}
          />
          <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>

        <Form.Group as={Col} xs={12} controlId="category-doc-name">
          <Form.Label>{"Categoria del documento *"}</Form.Label>
          <Form.Control
            name="category"
            placeholder={"categoria"}
            as="select"
            isInvalid={errors?.category}
            {...register("category", {
              required: "Este campo es obligatorio",
              validate: async (categoria) => {
                if (validation) return (await validation()) || `Documento de categoria: "${categoria}" ya se encuentra en nuestra base de datos`;
              },
            })}
          >
            {Object.keys(tiposDocumentos).length &&
              Object.keys(tiposDocumentos).map((keyTipoDocumento) => (
                <option key={keyTipoDocumento} value={keyTipoDocumento}>
                  {tiposDocumentos[keyTipoDocumento]}
                </option>
              ))}
          </Form.Control>
          <ErrorMessage errors={errors} name="category" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>

        <Form.Group as={Col} xs={12} controlId="description-doc-work">
          <Form.Label>{"Descripción"}</Form.Label>
          <Form.Control
            name="description"
            placeholder={"Descripción"}
            as="textarea"
            type="text"
            isInvalid={errors?.description}
            {...register("description", {
              maxLength: {
                value: 200,
                message: "El máximo de caracteres es 200",
              },
            })}
          />
          <ErrorMessage errors={errors} name="description" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} controlId="file-doc-work">
          <Form.Label>{"Documento *"}</Form.Label>
          <Form.Control
            name="file"
            type="file"
            accept=".pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            isInvalid={errors?.file}
            {...register("file", { required: "Este campo es obligatorio" })}
          />
          <ErrorMessage errors={errors} name="file" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className={"w-100"}>
          Añadir
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormAñadirDocumento;
